export default __webpack_public_path__ + "static/media/leon_municipal_seal.44b74df3.png";